document.addEventListener('DOMContentLoaded', function() {
  (function(window, document) {
    emailjs.init('xdwLBZpVcqOcZHm7S');

    var btn = document.getElementById('wr-submit');
    if (btn) {
      btn.addEventListener('click', function() {
        var name       = document.getElementById('wr-name').value.trim();
        var email      = document.getElementById('wr-email').value.trim();
        var bestellung = document.getElementById('wr-bestellung').value.trim();

        if (!name || !email || !bestellung) {
          alert('Bitte füllen Sie alle Pflichtfelder aus.');
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Wird gesendet...';

        var now = new Date();
        var datum = now.toLocaleDateString('de-DE') + ' um ' +
                    now.toLocaleTimeString('de-DE', {hour:'2-digit', minute:'2-digit'}) + ' Uhr';

        // 1. Bestätigung an Kunden via EmailJS
        emailjs.send('service_xaglhdf', 'template_vo9w8ul', {
          customer_name:  name,
          customer_email: email,
          bestellnummer:  bestellung,
          datum:          datum,
          shop_name:      'E-Mobility Shop'
        })
        .then(function() {
          // 2. Benachrichtigung an Shop via Formspree
          return fetch('https://formspree.io/f/mgojdawe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name:          name,
              email:         email,
              bestellnummer: bestellung,
              datum:         datum
            })
          });
        })
        .then(function() {
          document.getElementById('wr-formular').style.display = 'none';
          document.getElementById('wr-erfolg').style.display   = 'block';
        })
        .catch(function() {
          document.getElementById('wr-fehler').style.display = 'block';
          btn.disabled = false;
          btn.textContent = 'Widerruf jetzt absenden';
        });
      });
    }
  })(window, document);
});